export default __webpack_public_path__ + "static/postgres-6ee0805f078614a5f6cb1a19f13cb608.svg";